export default __webpack_public_path__ + "static/media/Taizhou-Municipal-Solid-Waste-1-point-5.7e9152fb.jpg";